<template>
  <v-overlay :value="true" opacity="1" color="primary" :z-index="1000">
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12" class="d-flex row justify-center align-center">
          <v-img src="@/assets/Logo-bt-06.png" width="480" class="animacion-logo"></v-img>
        </v-col>
        <v-progress-circular indeterminate size="84" width="8" color="white"
          class="animacion-process ma-5"></v-progress-circular>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<script>
/**
 * Overlay de pantalla completa. Es puramente presentacional: no decide cuando
 * mostrarse, eso lo resuelve el v-if de App.vue. Si esta montado, se ve.
 *
 * Antes tenia un `isLoading` en data fijo en true que nunca cambiaba, y mapeaba
 * un getter `overlay` que no usaba en ningun lado: daba la impresion de que el
 * componente gobernaba su propia visibilidad cuando no era asi.
 */
export default {
  name: 'Overlay',
};
</script>

<style scoped>
.animacion-logo {
  animation: opcidad 2.5s infinite ease;
}

.animacion-process {
  animation: process 2.5s infinite ease;
}

@keyframes opcidad {

  0%,
  100% {
    transform: scale(0.8);
    opacity: 0.65;
  }

  50% {
    transform: scale(1);
    opacity: 1;
  }

}

@keyframes process {

  0%,
  100% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }
}
</style>